<!-- @format -->

@if (validColors()?.length) {
	<div class="swatches hmf-display-flex hmf-align-items-center">
		@for (
			color of validColors() | slice: 0 : maxColorSwatchesToShow;
			track trackBySwatch($index, color)
		) {
			<homefield-color-swatch
				class="hmf-m-xxxs"
				radius="50%"
				height="21px"
				width="21px"
				[color]="color"
				[imageSrc]="getImageSource(color)"
				[colorSwatchHoverDimension]="true"
				[selected]="selectedSwatchColor === color"
				[isLazy]="isLazy()"
				(mouseover)="setImageColor(color)"
				(focus)="setImageColor(color)"
				(colorSwatchError)="
					handleImageError({ requestedImg: $event, color: color })
				"></homefield-color-swatch>
		}

		@if (validColors().length > maxColorSwatchesToShow) {
			<button
				hmf-action-text
				variant="secondary"
				class="hmf-m-xxxs"
				[ariaLabel]="moreColorsButtonAriaLabel"
				[linkURL]="assetSeoUrl()"
				[styled]="true"
				(click)="extraColorsClicked($event)">
				{{ validColors().length - maxColorSwatchesToShow }}+
			</button>
		}
	</div>
}
